"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.SHORTANSWER_FIELD = exports.RECAPTCHA = exports.RADIOBUTTON_FIELD = exports.POSTAL_CODE_FIELD = exports.PHONE_NUMBER_FIELD = exports.OPTIONAL = exports.NUMBER_FIELD = exports.NAME_FIELD = exports.LONGANSWER_FIELD = exports.HIDDEN_FIELD = exports.GENESYS_FIELD = exports.GENESYSTIMESLOTS_PICKER_FIELD = exports.GENESYSTIMESLOTS_DROPDOWN_FIELD = exports.FORM_COMPONENT = exports.FILE_UPLOAD_FIELD = exports.EMAIL_FIELD = exports.DROPDOWN_FIELD = exports.DATEPICKER_FIELD = exports.CONSENT_FIELD = exports.CHECKBOX_FIELD = exports.ADDRESS_FIELD = void 0;
var _react = _interopRequireDefault(require("react"));
var _componentsWeb = require("@telus-uds/components-web");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
var FORM_COMPONENT = exports.FORM_COMPONENT = {
  DEFAULT_SUBMIT_BUTTON: {
    en: 'Submit',
    fr: 'Soumettre'
  },
  THANK_YOU_MESSAGE: {
    en: 'Thank you for submitting your information. It has been saved.',
    fr: "Merci d'avoir transmis vos renseignements. Ils ont été enregistrés."
  },
  UNSUCCESSFUL_MESSAGE: {
    en: 'Something went wrong and your information was not saved. Please try again later.',
    fr: "Un problème est survenu et vos renseignements n'ont pas été enregistrés. Veuillez réessayer plus tard."
  },
  SPINNER_MESSAGE: {
    en: 'Submitting...',
    fr: 'Envoi...'
  }
};
var OPTIONAL = exports.OPTIONAL = {
  en: 'optional',
  fr: 'facultatif'
};
var NAME_FIELD = exports.NAME_FIELD = {
  FIRST_NAME: 'First Name',
  LAST_NAME: 'Last Name',
  VALIDATION_ERROR: {
    en: 'Please enter a valid name',
    fr: 'Veuillez indiquer un nom valide'
  },
  DEFAULT_LABEL: 'Name'
};
var PHONE_NUMBER_FIELD = exports.PHONE_NUMBER_FIELD = {
  VALIDATION_ERROR: {
    en: 'Please enter a valid phone number',
    fr: 'Veuillez indiquer un numéro de téléphone valide'
  },
  DEFAULT_LABEL: 'Phone Number',
  PLACEHOLDER: '+1(555) 555-5555'
};
var NUMBER_FIELD = exports.NUMBER_FIELD = {
  VALIDATION_ERROR: {
    en: 'Please enter a valid number',
    fr: 'Veuillez indiquer un nombre valide'
  },
  MIN_MAX_MESSAGE: {
    MIN: {
      en: 'minimum value:',
      fr: 'valeur minimale:'
    },
    MAX: {
      en: 'maximum value:',
      fr: 'valeur maximale:'
    }
  },
  DEFAULT_LABEL: 'Number'
};
var ADDRESS_FIELD = exports.ADDRESS_FIELD = {
  VALIDATION_ERROR: {
    en: 'Invalid address, please select from the available options.',
    fr: 'Adresse invalide, veuillez choisir parmi les options disponibles.'
  },
  VALIDATION_ERROR_STRING_REGEX: {
    en: "This field only accepts characters [0-9, a-z, A-Z, À-ż] and special characters (.+_!@,^%#$=:|'`‘’?*/&[];-)",
    fr: "Ce champ accepte uniquement les caractères [0-9, a-z, A-Z, À-ż] et les caractères spéciaux suivants (.+_!@,^%#$=:|'`‘’?*/&[];-)"
  },
  DEFAULT_LABEL: 'Address',
  UNIT: {
    DEFAULT_LABEL: 'Unit Number',
    VALIDATION_ERROR: {
      en: 'Please enter a valid unit number',
      fr: 'Veuillez indiquer une numéro unité valide'
    },
    VALIDATION_ERROR_STRING_TOOLONG: {
      en: 'Your entry exceeds the maximum length of:',
      fr: 'Vous avez dépassé le maximum de caractères de:'
    },
    VALIDATION_ERROR_STRING_REGEX: {
      en: "This field only accepts characters [0-9, a-z, A-Z, À-ż] and special characters (.+_!@,^%#$=:|'`‘’?*/&[];-)",
      fr: "Ce champ accepte uniquement les caractères [0-9, a-z, A-Z, À-ż] et les caractères spéciaux suivants (.+_!@,^%#$=:|'`‘’?*/&[];-)"
    }
  },
  LOADING_LABEL: {
    en: 'Searching...',
    fr: 'Recherche...'
  },
  NO_RESULTS_LABEL: {
    en: 'No results found',
    fr: 'Aucun résultat trouvé'
  }
};
var POSTAL_CODE_FIELD = exports.POSTAL_CODE_FIELD = {
  VALIDATION_ERROR: {
    en: 'Please enter a valid postal code',
    fr: 'Veuillez indiquer un code postal valide'
  },
  DEFAULT_LABEL: 'Postal Code',
  PLACEHOLDER: 'V6B 0M3'
};
var EMAIL_FIELD = exports.EMAIL_FIELD = {
  FORMAT_ERROR: {
    en: 'Ensure the email you entered is valid',
    fr: 'Assurez-vous que le courriel indiqué est valide'
  },
  CONFIRM: {
    en: 'Confirm your email',
    fr: 'Confirmez votre courriel'
  },
  CONFIRM_ERROR: {
    en: 'Ensure this email matches the one above',
    fr: 'Assurez-vous que le courriel indiqué est identique au précédent'
  },
  DEFAULT_LABEL: 'Email',
  CONFIRM_DEFAULT_LABEL: 'Confirm your email'
};
var DATEPICKER_FIELD = exports.DATEPICKER_FIELD = {
  FORMAT_ERROR: {
    en: 'Ensure the date you entered is valid',
    fr: 'Assurez-vous que la date spécifiée est valide'
  },
  DEFAULT_LABEL: 'Date',
  DEFAULT_VARIANT: 'Regular',
  VARIANTS: ['Regular', 'Inline'],
  DATEPICKER_TYPE: ['Normal', 'Genesys'],
  PLACEHOLDER: {
    en: 'DD/MM/YYYY',
    fr: 'JJ/MM/AAAA'
  }
};
var minCharsEn = 'Minimum characters required:';
var minCharsFr = 'Nombre minimum de caractères requis:';
var HIDDEN_FIELD = exports.HIDDEN_FIELD = {
  VALIDATION_ERROR_NO_INPUT: {
    en: 'Please provide a valid answer',
    fr: 'Veuillez indiquer une réponse valide'
  }
};
var SHORTANSWER_FIELD = exports.SHORTANSWER_FIELD = {
  VALIDATION_ERROR_NO_INPUT: {
    en: 'Please provide a valid answer',
    fr: 'Veuillez indiquer une réponse valide'
  },
  VALIDATION_ERROR_STRING_TOOSHORT: {
    en: minCharsEn,
    fr: minCharsFr
  },
  VALIDATION_ERROR_STRING_TOOLONG: {
    en: 'Your entry exceeds the maximum length of:',
    fr: 'Vous avez dépassé le maximum de caractères de:'
  },
  VALIDATION_ERROR_STRING_REGEX: {
    en: "This field only accepts characters [0-9, a-z, A-Z, À-ż] and special characters (.+_!@,^%#$=:|'`‘’?*/&[];-)",
    fr: "Ce champ accepte uniquement les caractères [0-9, a-z, A-Z, À-ż] et les caractères spéciaux suivants (.+_!@,^%#$=:|'`‘’?*/&[];-)"
  },
  VALIDATION_ERROR_NUMERIC_REGEX: {
    en: 'This field only accepts characters [0-9]',
    fr: 'Ce champ accepte uniquement les caractères [0-9]'
  },
  VALIDATION_ERROR_LETTERS_REGEX: {
    en: 'This field only accepts characters [a-z, A-Z, À-ż]',
    fr: 'Ce champ accepte uniquement les caractères [a-z, A-Z, À-ż]'
  },
  VALIDATION_ERROR_ALPHANUMERIC_REGEX: {
    en: 'This field only accepts characters [0-9, a-z, A-Z, À-ż]',
    fr: 'Ce champ accepte uniquement les caractères [0-9, a-z, A-Z, À-ż]'
  },
  DEFAULT_LABEL: 'Short Answer',
  VALIDATION_VARIANT_NUMERIC: 'Numbers',
  VALIDATION_VARIANT_LETTERS: 'Letters',
  VALIDATION_VARIANT_ALPHANUMERIC: 'Alphanumeric',
  VALIDATION_VARIANT_DEFAULT: 'All'
};
var LONGANSWER_FIELD = exports.LONGANSWER_FIELD = {
  VALIDATION_ERROR_NO_INPUT: {
    en: 'Please provide a valid answer',
    fr: 'Veuillez indiquer une réponse valide'
  },
  VALIDATION_ERROR_STRING_TOOSHORT: {
    en: minCharsEn,
    fr: minCharsFr
  },
  VALIDATION_ERROR_STRING_TOOLONG: {
    en: 'Your entry exceeds the maximum length of:',
    fr: 'Vous avez dépassé le maximum de caractères de:'
  },
  VALIDATION_ERROR_STRING_REGEX: {
    en: "This field only accepts characters [0-9, a-z, A-Z, À-ż] and special characters (.+_!@,^%#$=:|'`‘’?*/&[];-)",
    fr: "Ce champ accepte uniquement les caractères [0-9, a-z, A-Z, À-ż] et les caractères spéciaux suivants (.+_!@,^%#$=:|'`‘’?*/&[];-)"
  },
  DEFAULT_LABEL: 'Long Answer'
};
var DROPDOWN_FIELD = exports.DROPDOWN_FIELD = {
  VALIDATION_ERROR: {
    en: 'Please select an option',
    fr: 'Veuillez sélectionner une option'
  },
  DEFAULT_LABEL: 'Drop down',
  PLACEHOLDER: {
    en: 'Please select...',
    fr: 'Veuillez choisir...'
  }
};
var GENESYSTIMESLOTS_PICKER_FIELD = exports.GENESYSTIMESLOTS_PICKER_FIELD = {
  VALIDATION_ERROR: {
    en: 'Please select an option',
    fr: 'Veuillez sélectionner une option'
  },
  DEFAULT_LABEL: 'Select Date',
  PLACEHOLDER: {
    en: 'Please select date...',
    fr: 'Veuillez choisir...'
  }
};
var GENESYSTIMESLOTS_DROPDOWN_FIELD = exports.GENESYSTIMESLOTS_DROPDOWN_FIELD = {
  VALIDATION_ERROR: {
    en: 'Please select an option',
    fr: 'Veuillez sélectionner une option'
  },
  DEFAULT_LABEL: 'Select Time',
  PLACEHOLDER: {
    en: 'Please select time...',
    fr: 'Veuillez choisir...'
  }
};
var RADIOBUTTON_FIELD = exports.RADIOBUTTON_FIELD = {
  ERROR_MSG: {
    en: 'Please select at least one option',
    fr: 'Veuillez sélectionner au moins une option'
  }
};
var CHECKBOX_FIELD = exports.CHECKBOX_FIELD = {
  ERROR_MSG: {
    en: 'Please select the required number of options',
    fr: "Veuillez sélectionner le nombre d'options requis"
  },
  MIN_MAX_MESSAGE: {
    MIN: {
      en: 'between',
      fr: 'entre'
    },
    MAX: {
      en: 'and',
      fr: 'et'
    }
  }
};
var FILE_UPLOAD_FIELD = exports.FILE_UPLOAD_FIELD = {
  VALIDATION_ERROR_NO_INPUT: {
    en: 'Please provide a valid file',
    fr: 'Veuillez indiquer un fichier valide'
  }
};
var CONSENT_FIELD = exports.CONSENT_FIELD = {
  CHECKBOX_LABEL: {
    en: 'I consent to receiving electronic messages from TELUS.',
    fr: 'Je consens à recevoir des communications électroniques de TELUS.'
  },
  ERROR_MESSAGE: {
    en: 'Please provide your consent to receive future TELUS email updates.',
    fr: 'Veuillez consentir à l’envoi de courriels pour recevoir les mises à jour de TELUS.'
  },
  LEGAL_SHS: {
    // NOTE: here I'm intentionally disabling the linting rule, as this rule applies
    // maintly to React components. Here we have our first use-case of mixing hyperlinks
    // with hard-coded strings. Due to this requirement, we needed to convert this file
    // to support React so that we can use JSX
    /* eslint-disable react/jsx-one-expression-per-line */
    en: /*#__PURE__*/_react.default.createElement(_componentsWeb.Typography, {
      variant: {
        size: 'medium'
      }
    }, "By clicking Upgrade now, you agree to the", ' ', /*#__PURE__*/_react.default.createElement(_componentsWeb.Link, {
      href: "https://www.telus.com/en/support/article/telus-online-security-service-terms",
      variant: {
        size: 'medium'
      }
    }, "TELUS Online Security Service Terms"), ' ', "and the", ' ', /*#__PURE__*/_react.default.createElement(_componentsWeb.Link, {
      href: "https://www.nortonlifelock.com/ca/en/legal/license-services-agreement/",
      variant: {
        size: 'medium'
      }
    }, "NortonLifeLock License and Service Agreement"), "."),
    fr: /*#__PURE__*/_react.default.createElement(_componentsWeb.Typography, {
      variant: {
        size: 'medium'
      }
    }, "En cliquant sur Changer de forfait, vous acceptez les", ' ', /*#__PURE__*/_react.default.createElement(_componentsWeb.Link, {
      href: "https://www.telus.com/fr/support/article/telus-online-security-service-terms",
      variant: {
        size: 'medium'
      }
    }, "modalit\xE9s de service du service Protection num\xE9rique de TELUS"), ' ', "et le", ' ', /*#__PURE__*/_react.default.createElement(_componentsWeb.Link, {
      href: "https://www.nortonlifelock.com/ca/en/legal/license-services-agreement/?country=ca&lang=fr",
      variant: {
        size: 'medium'
      }
    }, "contrat de licence et de services de NortonLifeLock"), ".")
    /* eslint-enable react/jsx-one-expression-per-line */
  },
  LEGAL_STATEMENT: {
    // NOTE: here I'm intentionally disabling the linting rule, as this rule applies
    // maintly to React components. Here we have our first use-case of mixing hyperlinks
    // with hard-coded strings. Due to this requirement, we needed to convert this file
    // to support React so that we can use JSX
    /* eslint-disable react/jsx-one-expression-per-line */
    en: /*#__PURE__*/_react.default.createElement(_componentsWeb.Typography, {
      variant: {
        size: 'small'
      }
    }, "We will use your email address to send you information about promotions, special offers and news about TELUS events and services. All communications will be coming from TELUS, Marketing Preferences, 30 Floor, 25 York Street, Toronto ON M5J 2V5,", ' ', /*#__PURE__*/_react.default.createElement(_componentsWeb.Link, {
      href: "https://www.telus.com",
      variant: {
        size: 'small'
      }
    }, "www.telus.com"), ". We assure you that your email address will not be shared with any third party. You can withdraw your consent to receive electronic messages from TELUS at any time. Your personal information will be used in accordance with our", ' ', /*#__PURE__*/_react.default.createElement(_componentsWeb.Link, {
      href: "https://www.telus.com/en/about/privacy",
      variant: {
        size: 'small'
      }
    }, "Privacy Policy"), "."),
    fr: /*#__PURE__*/_react.default.createElement(_componentsWeb.Typography, {
      variant: {
        size: 'small'
      }
    }, "Nous utiliserons votre adresse courriel pour vous transmettre des renseignements et des nouvelles au sujet des promotions, services et offres sp\xE9ciales de TELUS. Toutes les communications proviendront de TELUS. Voici nos coordonn\xE9es : Pr\xE9f\xE9rences marketing, 30e \xE9tage, 25, rue York, Toronto (Ontario) M5J 2V5,", ' ', /*#__PURE__*/_react.default.createElement(_componentsWeb.Link, {
      href: "https://www.telus.com",
      variant: {
        size: 'small'
      }
    }, "www.telus.com"), ". Nous ne partagerons pas votre adresse courriel avec d\u2019autres organisations. Vous pouvez retirer votre consentement \xE0 recevoir des communications \xE9lectroniques de TELUS \xE0 tout moment. Vos renseignements personnels seront utilis\xE9s conform\xE9ment avec notre", ' ', /*#__PURE__*/_react.default.createElement(_componentsWeb.Link, {
      href: "https://www.telus.com/fr/about/privacy",
      variant: {
        size: 'small'
      }
    }, "Politique de protection de la vie priv\xE9e"), ".")
    /* eslint-enable react/jsx-one-expression-per-line */
  }
};
var RECAPTCHA = exports.RECAPTCHA = {
  MESSAGE: _ref => {
    var {
      inverse,
      language
    } = _ref;
    switch (language) {
      case 'fr':
        return /*#__PURE__*/_react.default.createElement(_componentsWeb.Typography, {
          variant: {
            size: 'small',
            inverse
          }
        }, "Ce site est prot\xE9g\xE9 par reCAPTCHA Enterprise et", ' ', /*#__PURE__*/_react.default.createElement(_componentsWeb.Link, {
          href: "https://policies.google.com/privacy?hl=fr-CA",
          variant: {
            size: 'small'
          }
        }, "Politique de confidentialit\xE9"), ' ', "et les", ' ', /*#__PURE__*/_react.default.createElement(_componentsWeb.Link, {
          href: "https://policies.google.com/terms?hl=fr-CA",
          variant: {
            size: 'small'
          }
        }, "conditions d'utilisation"));
      case 'en':
      default:
        return /*#__PURE__*/_react.default.createElement(_componentsWeb.Typography, {
          variant: {
            size: 'small',
            inverse
          }
        }, "This site is protected by reCAPTCHA Enterprise and the Google", ' ', /*#__PURE__*/_react.default.createElement(_componentsWeb.Link, {
          href: "https://policies.google.com/privacy?hl=en-CA",
          variant: {
            size: 'small'
          }
        }, "Privacy Policy"), ' ', "and", ' ', /*#__PURE__*/_react.default.createElement(_componentsWeb.Link, {
          href: "https://policies.google.com/terms?hl=en-CA",
          variant: {
            size: 'small'
          }
        }, "Terms of Service"));
    }
  }
};
var GENESYS_FIELD = exports.GENESYS_FIELD = {
  TITLE_ERROR_NO_DATA: {
    en: 'Error',
    fr: 'Erreur'
  },
  VALIDATION_ERROR_NO_DATA: {
    en: "We're unable to load upcoming available appointment at the moment. Please try again.",
    fr: 'Nous ne sommes pas capables de charger les prochains rendez-vous disponibles pour le moment. Veuillez réessayer.'
  }
};
var staticConentFields = {
  FORM_COMPONENT,
  NAME_FIELD,
  PHONE_NUMBER_FIELD,
  NUMBER_FIELD,
  ADDRESS_FIELD,
  EMAIL_FIELD,
  SHORTANSWER_FIELD,
  LONGANSWER_FIELD,
  DROPDOWN_FIELD,
  RADIOBUTTON_FIELD,
  CHECKBOX_FIELD,
  CONSENT_FIELD,
  RECAPTCHA,
  DATEPICKER_FIELD,
  GENESYSTIMESLOTS_PICKER_FIELD,
  GENESYSTIMESLOTS_DROPDOWN_FIELD
};
var _default = exports.default = staticConentFields;